var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold relative widget-title",class:{
    'grey--text text--darken-4': !_vm.light,
    'white--text': _vm.light,
    'text-h5 text-md-h4 text-lg-h3 text-center pb-5': !_vm.small,
    'text-h6 text-md-h5 pb-3': _vm.small,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }